import script from "./UploadProgress.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadProgress.vue?vue&type=script&lang=ts&setup=true"

import "./UploadProgress.vue?vue&type=style&index=0&id=6671c48a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6671c48a"]])

export default __exports__